<template>
	<div  class="top-line">	
		<div style="color: #FF9900;">后台审核后才生成待支付定金单</div>
		<div class="d-flex search-wrap">
			<div class="d-flex">
				<b-input-group style="width:220px;margin-right:10px;">
					<b-form-input size="sm" autocomplete="off" v-model="intentionBillRecordCode" placeholder="输入查询意向单号" class="order-input"></b-form-input>
				</b-input-group>

				<DatePicker type="daterange" v-model="selectDates" transfer placement="bottom-end" placeholder="选择意向定单时间"
					style="width: 200px;" @on-change="onDateChange" class="search-input"></DatePicker>
				<b-input-group style="width:220px;margin-right:10px;">
					<b-form-input size="sm" autocomplete="off" v-model="operatorName" placeholder="输入经办人账号或姓名" class="order-input"></b-form-input>
				</b-input-group>
				<b-button size="sm" v-on:click="onSearch()" variant="success" class="order-button">查询</b-button>
				<b-button style="margin-left: 20px;" size="sm" v-on:click="clearSearch()" variant="success" class="order-button">重置</b-button>
				<!-- <b-input-group style="width:220px; margin-left:10px;">
					<b-form-select
						  v-model="operatorType"
						  style="height: 32px; padding: 0 0 0 2px;"
					      class="mb-2 mr-sm-2 mb-sm-0"
					      :options="{ 'F': '客户本人', 'B': '苗场', 'G': '客户经理' }"
					      id="inline-form-custom-select-pref"
					    >
						<template v-slot:first>
						    <option :value="null">请选择经办人</option>
						    </template>
						</b-form-select>

				</b-input-group>	 -->
			</div>
		</div>
		<div class="delivery-list">
			<b-table id="deposit-table" :fields="intentionBillList.fields" :items="intentionBillList.intentionBillMainVOList" small bordered
				hover show-empty empty-text="没有找到匹配的记录" :busy="intentionBillList.isTableBusy" caption-top>
				<template slot="table-caption">
					<!-- <span>苗定单列表</span> -->
				</template>
				<div slot="table-busy" class="text-center text-info my-2">
					<b-spinner class="align-middle"></b-spinner>
					<strong>加载中...</strong>
				</div>
				<template v-slot:cell(intentionBillListAction)="row">
					<b-link
						:to="{path: '/member/intention-detail', query: { intentionBillRecordUuid: row.item.intentionBillRecordUuid }}"
						target="_blank">查看</b-link>            
					/<a  href="javascript:void(0);" @click="closeIntention(row.item.intentionBillRecordUuid)" >关闭</a>
					<!-- <span v-if="row.item.paidStatus=='定金已支付'">
						/
						<a href="#" v-on:click="onPayOrder(row)">支付余额</a>
					</span> -->
				</template>
				<template v-slot:cell(intentionBillRecordDepositPaymentSum)="row">
					<span>{{getNumberThousandString(row.item.intentionBillRecordDepositPaymentSum,'0.00')}}</span>
				</template>
				<template v-slot:cell(surplus)="row">
					<span>{{getNumberThousandString(row.item.surplus,'0.00')}}</span>
				</template>
				<template v-slot:cell(totalFee)="row">
					<span>{{getNumberThousandString(row.item.totalFee,'0.00')}}</span>
				</template>
				<template v-slot:cell(intentionBillRecordCreateAt)="row">
					<span>{{formatDateTimeString(row.item.intentionBillRecordCreateAt)}}</span>
				</template>
				<!-- 待付余额 -->
				<!-- <template v-slot:cell(remainingSum)="row">
					<span>{{row.item.mainTotalMoney-row.item.intentionBillRecordDepositPaymentSum}}</span>
				</template> -->
			</b-table>
			<div class="pageControl">
			    <b-pagination v-model="intentionBillList.feSearch.limit.conditions.pageStart"
			        style="margin-top:20px;"
					:total-rows="intentionBillList.feSearch.limit.conditions.total"
			        :per-page="intentionBillList.feSearch.limit.conditions.pageLength"
			        align="center"
			        size="sm"
			        ellipsis-text="..."
			        first-text="首页"
			        prev-text="上一页"
			        next-text="下一页"
			        last-text="尾页"
			        limit="10"
			        @change="onDepositPageChange"></b-pagination>
			</div>
		</div>

		<PayModal ref="payModal" />
	</div>
</template>

<script>
	import api from "@/api/api";
	import {
		formatDateTimeString,
		getNumberThousandString,
		numberToFixed
	} from "@/libs/utils";
	import search from '@/libs/search';
	import "@/style/global.css";
	import PayModal from '../member/pay';
import { param } from "jquery";
	export default {
		name: "OrderList",
		components: {
			PayModal
		},
		data() {
			return {
				api,
				selectDates: [],
				intentionBillRecordCode:'',
				operatorName:'',
				operatorType:'',
				intentionBillList: {
					fields: [{
							key: "intentionBillRecordCode",
							label: "意向单编号"
						},
						{
							key: "seedFarmName",
							label: "苗场名称"
						},
						{
							key: "weekSeq",
							label: "周次"
						},
						{
							key: "sendProductDate",
							label: "发货日期"
						},
						{
							key: "receiptFullAddress",
							label: "收货地址"
						},
						// {
						// 	key: "intentionBillRecordDepositPaymentSum",
						// 	label: "待支付定金"
						// },
						// {
						// 	key: "surplus",
						// 	label: "待付余额"
						// },
						{
							key: "totalFee",
							label: "产品总额"
						},
						{
							key: "intentionBillRecordOrderStatus",
							label: "状态"
						},
						{
							key: "intentionBillRecordCreateAt",
							label: "下单时间",
							render: (h, params) => formatDateTimeString(h, params.row.intentionBillRecordCreateAt)
						},
						{
							key: "operatorName",
							label: "经办人"
						},
						{
							key: "intentionBillListAction",
							label: "操作"
						}
					],
					keyword: '',
					intentionBillMainVOList: [],
					isTableBusy: false,
					feSearch: search.getSearchParams()
				},
                paymentTypeModel: {
                    show: false,
                    depositValue: 0,
                    selectedType: "fund",
                    memberFund: 0
                },
				payDeposteModel: {
					show: false,
					preSaleOrderRecordUuid: '',
					preSaleOrderRecordCode: '',
					preSaleOrderRecordTotalOrderCost: '',
					intentionBillRecordDepositPaymentSum: '',
					remainSum: '',
					discount:''
				},
                intentionBillRecordUuidArray: []
			};
		},
		mounted() {
			if (!this.checkMemberLogin()) {
				this.$router.push({
					name: 'MemberLogin'
				});
				return;
			};
			this.intentionBillList.feSearch.filters.enable = false;
			this.intentionBillList.feSearch.filters.conditions = [];
			this.getUserDepositBillInfoList();
			this.getMemberBalance();
		},
		methods: {
			formatDateTimeString,
			getNumberThousandString,
			numberToFixed,
			getMemberBalance() {
				api.webGetMemberUserDetail({
					userUuid: this.getLoginCookieUuid()
				}).then(res => {
					if (res.code === 0) {
						this.paymentTypeModel.memberFund = res.data.memberFund;
					}
				});
			},
			onDateChange(e) {
				this.selectDates = e;
				let field = "intentionBillRecordCreateAt";
				search.globalRemoveFilterConditionKey(this.intentionBillList.feSearch, field);
				search.globalResetSearch(this.intentionBillList.feSearch);
				this.intentionBillList.feSearch.filters.enable = true;
				this.intentionBillList.feSearch.filters.conditions.push({
				    name: field,
				    type: 'datebetween',
				    value: JSON.stringify(e)
				});
				this.getUserDepositBillInfoList();
			},
			onSearch() {
				if(this.intentionBillRecordCode){
					let field = "intentionBillRecordCode";
					search.globalRemoveFilterConditionKey(this.intentionBillList.feSearch, field);
					search.globalResetSearch(this.intentionBillList.feSearch);
					this.intentionBillList.feSearch.filters.enable = true;
					this.intentionBillList.feSearch.filters.conditions.push({
						name: field,
						type: 'like',
						value: this.intentionBillRecordCode
					});
				}
				if(this.operatorName){
					let field = 'concat(uers.userPersonName, uers.userName)';
					search.globalRemoveFilterConditionKey(this.intentionBillList.feSearch, field);
					search.globalResetSearch(this.intentionBillList.feSearch);
					this.intentionBillList.feSearch.filters.enable = true;
					this.intentionBillList.feSearch.filters.conditions.push({
						name: field,
						type: 'like',
						value: this.operatorName
					});
				}
				this.getUserDepositBillInfoList();
			},
			clearSearch(){
				this.selectDates=[];
				this.intentionBillRecordCode='';
				this.operatorName='';
				this.intentionBillList.feSearch.filters.enable = false;
				this.intentionBillList.feSearch.filters.conditions = [];
				this.getUserDepositBillInfoList();
			},
			getUserDepositBillInfoList() {
				//获取定金待支付的列表
				this.intentionBillList.isTableBusy = true;
				api.webGetIntentionBillOrderList  (this.intentionBillList.feSearch).then(res => {
					// uni.hideLoading();
					this.intentionBillList.isTableBusy = false;
					if (res.code === 0) {
						if (res.data.intentionBillMainVOList.length > 0) {
							this.intentionBillList.intentionBillMainVOList = res.data.intentionBillMainVOList;
							this.intentionBillList.intentionBillMainVOList.forEach(e => {
								if(e.intentionBillRecordOrderStatus=="关闭"){
								       e.intentionBillRecordPaidStatus="关闭";
								}
								e.intentionBillRecordDepositPaymentSum=this.numberToFixed(e.intentionBillRecordDepositPaymentSum,2);
								e.surplus=this.numberToFixed(e.totalFee-e.intentionBillRecordDepositPaymentSum,2)
								e.totalFee=this.numberToFixed(e.totalFee,2);
							});
							// 获取分页条数
							search.globalSetFilterRecordCount(this.intentionBillList.feSearch, res.data.filterRecordCount);
						}
						else{
							this.intentionBillList.intentionBillMainVOList =[];
						}
					}
				});
			},
			onDepositPageChange(pageNum) {
				search.globalPageOnChange(this.intentionBillList.feSearch, pageNum);
				this.getUserDepositBillInfoList();
			},
			onPayOrder(row) {
				this.$bvModal
					.msgBoxConfirm("是否确认支付该定单？", {
						size: "sm",
						buttonSize: "sm",
						okVariant: "danger",
						okTitle: "是",
						cancelTitle: "否"
					})
					.then(value => {
						if (value) {
							this.payDeposteModel.preSaleOrderRecordUuid = row.item.intentionBillRecordUuid;
							this.payDeposteModel.preSaleOrderRecordCode = row.item.intentionBillRecordCode;
							this.payDeposteModel.preSaleOrderRecordTotalOrderCost = row.item.totalFee;
							this.payDeposteModel.intentionBillRecordDepositPaymentSum = row.item.intentionBillRecordDepositPaymentSum;
							this.payDeposteModel.discount=(row.item.mainTotalMoney*1000+row.item.packageFee*1000+row.item.deliveryFee*1000-row.item.totalFee*1000)/1000;
							// this.payDeposteModel.remainSum = row.item.mainTotalMoney-row.item.intentionBillRecordDepositPaymentSum;
							this.payDeposteModel.remainSum = ((row.item.totalFee *1000)-(row.item.intentionBillRecordDepositPaymentSum * 1000))/1000;
							this.payDeposteModel.show = true;
						}
					});
			},
			submitBookingOrderDeposite() {
                this.intentionBillRecordUuidArray.push(this.payDeposteModel.preSaleOrderRecordUuid);
				api.webPreSaleDepositPayWithFund({intentionBillRecordUuidArray:this.intentionBillRecordUuidArray,orderType:'REMAININGMONEY'}).then(res => {
					if (res.code === 0) {
						this.payDeposteModel.show = false;
                        this.$bvModal.msgBoxOk("支付成功", {
                        	title: "温馨提示",
                        	buttonSize: "sm"
                        });
						this.getUserDepositBillInfoList();
					} else {
						if (res.message === '余额不足') {
							this.$refs.payModal.showModal();
						}
					}
				});
			},
			submitSalesPayment() {
				if (this.paymentTypeModel.selectedType === "fund") {
					api.webCurrentSalePayWithFund(this.paymentTypeModel).then(res => {
						if (res.code === 0) {
							this.paymentTypeModel.show = false;
							this.getUserDepositBillInfoList();
						} else {
							if (res.message === '余额不足') {
								this.$refs.payModal.showModal();
							}
						}
					});
				} else {
					this.$bvModal.msgBoxOk("暂不支持该支付方式", {
						title: "提示",
						buttonSize: "sm"
					});
				}
			},
            onSginContract(row) {
                this.intentionBillList.isTableBusy = true;
                api.AutoSignContract({
                    shoppingType: '预售',
                    orderUuid: row.item.intentionBillRecordUuid
                }).then(res => {
                    this.intentionBillList.isTableBusy = false;
                    if (res.code === 0) {
                        window.open(res.data.signResult, "_blank");
                    }
                });
            },
			closeIntention(intentionBillRecordUuid){
				this.intentionBillList.isTableBusy = true;
                api.closeIntentionBillOrder({intentionBillRecordUuid}).then(res=>{
                    this.intentionBillList.isTableBusy = false;
					if(res.code==0){
						this.$bvModal.msgBoxOk("意向单关闭成功", {
						title: '提示',
						buttonSize: 'sm'
					})
					this.getUserDepositBillInfoList();
					}
				})
			}
		}
	};
</script>

<style>
	.search-wrap {
		margin-top: 10px;
	}

	/* 选择下单日期 */
	.search-input .ivu-input {
		height: 32px;
		line-height: 32px;
		width: 200px;
		padding: 0px 7px;
		color: #333;
	}

	.search-input .ivu-input-prefix i,
	.ivu-input-suffix i {
		font-size: 22px;
		line-height: 32px;
		color: #808695;
	}


	.order-input {
		height: 32px;
		line-height: 32px;
		width: 220px;
		padding: 0px 7px;
		color: #333;
	}

	.order-button {
		height: 32px;
		line-height: 32px;
		width: 50px;
		padding: 0px;
	}

	.custom-control-input:checked~.custom-control-label::before {
		color: #fff !important;
		border-color: #28a745 !important;
		background-color: #28a745 !important;
	}

	.custom-checkbox .custom-control-input:checked~.custom-control-label::after {
		background-color: #01B252 !important;
	}

    .delivery-list{margin-top: 20px;}
    .delivery-list th {
    	background-color: #efefef;
    	height: 40px;
    	line-height: 40px;
    }
    .delivery-list tr{text-align: center;background:#fafafa;}
    .delivery-list th{background:#fafafa;}
    .delivery-list td{font-size: 14px;}

    .table thead th {
    	vertical-align: bottom;
    	border-bottom: 2px solid #dbdbdb;
    }

	/* 表格 */
	.dataTable {
		margin-top: 20px;
	}

	.dataTable th {
		background-color: #efefef;
		height: 32px;
		line-height: 32px;
	}

	.table thead th {
		vertical-align: bottom;
		border-bottom: 2px solid #dbdbdb;
	}

	.table-bordered td,
	.table-bordered th {
		border: 1px solid #dbdbdb;
	}

	.table-sm td,
	.table-sm th {
		padding: 10px 5px;
	}

	/* 表格操作 */
	.table-sm td a {
		color: #00B151;
	}

	/* 页码 */
	.page-link {
		color: #757575 !important;
	}

	.page-link:hover {
		color: #00b151 !important;
	}

	.page-item.active .page-link {
		color: #fff !important;
		background-color: #28a745 !important;
		border-color: #28a745 !important;
	}

	.pagination-sm .page-link {
		padding: 5px 12px !important;
		margin-top: 40px;
	}

	.page-link:focus {
		box-shadow: none !important;
	}



	.radio-wrap .custom-control-label {
		padding-top: 0px;
	}
</style>



// WEBPACK FOOTER //
// src/view/intention-list/index.vue